export enum Countries { // DO NOT USE: USE THE * counties from i18n-iso-countries - to do: remove and refactor
  at = 'AUT',
  de = 'DEU',
}

export enum PayoutStatus {
  init = 'init',
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
  rejected = 'rejected',
  transferred = 'transferred',
  queued = 'queued',
}

export enum TInvestmentMaturity {
  no,
  yes,
}

export enum TTerminationRightFrequency {
  five = '5',
  ten = '10',
  fiveteen = '15',
  twenty = '20',
}

export enum ETaxType {
  KESt = 'KESt',
  KapESt = 'KapESt',
  Soli = 'Soli',
  Kirchensteuer = 'Kirchensteuer',
  none = 'no tax',
}

export enum EApplicableTo {
  capitalGains = 'capitalGains',
  capitalTaxes = 'capitalTaxes',
}

export enum TReportingDocumentType {
  expertProtocol = 'expertProtocol',
  landRegister = 'landRegister',
  energyCertificate = 'energyCertificate',
  utilityReport = 'utilityReport',
  rentalAgreement = 'rentalAgreement',
  investmentConditions = 'investmentConditions',
  investmentInformation = 'investmentInformation',
  riskReport = 'riskReport',
  other = 'other',
}
